import { render, staticRenderFns } from "./SettingsHeadbar.vue?vue&type=template&id=31bc6ce9&"
import script from "./SettingsHeadbar.vue?vue&type=script&lang=js&"
export * from "./SettingsHeadbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports